import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Modal } from 'react-overlays';
import _ from 'lodash';
import BaseComponent from '../../../baseClasses/BaseComponent';
import animator from '../../../helpers/animator';
import ProjectHeader from '../../TasksContainer/ProjectHeader';
import AssignmentPullout from '../AssignmentPullout';
import QuickerAssignPopup from '../../../components/QuickerAssignPopup';
import QuickerAssignErrorPopup from '../../../components/QuickerAssignErrorPopup';
import dataModel from '../../../models/DataModel';
import PageStateDAO from '../../../dao/PageStateDAO';
import BreadCrumbs from '../../../components/BreadCrumbs';
import { PageNames } from '../../../constants/ReduxConstants';
import * as BuildOwnerPermissionsUtil from '../../../helpers/permissions/BuildOwnerPermissionsUtil';
import DataSource from '../../../dao/DataSource/DataSource';

import AnalyticsLogger from '../../../helpers/analytics/analyticsLogger';
import WaitSpinner from '../../../components/WaitSpinner';
import TaskSwimLanes from '../../TasksContainer/TasksContainerTasks/TaskSwimLanes';
import { build_root } from '../../../dao/BuildsDAO';

import './ProjectsContainerTasks.scss';

// TODO: refactoring
class ProjectsContainerTasks extends BaseComponent {
  constructor(props) {
    super(props);
    this.animator = new animator();
    
    this.selectedTaskIds = new Set(); //used for bulk assign
    this.selectedTasks = [];

    const currentRole = props.currentUser ? props.currentUser.role : null;
    this.analyticsLogger = new AnalyticsLogger({
      currentRole,
      isMobile: !!window.cordova,
    });

    const pageState = PageStateDAO.findPageState(PageNames.PROJECTS_CONTAINER);
    this.state = { 
      selectedTask: null, 
      displayHeight: 0, 
      selectedTasksCount: 0, 
      mapExpanded: pageState ? pageState.mapExpanded : false,
      myTasksNotStarted: { tasks: [] },
      myTasksInProgress: { tasks: [] },
      myTasksUnderReview: { tasks: [] },
      myTasksCompleted: { tasks: [] },
      tasksInitialized: false,
    };

    this.addSelectedTask = this.addSelectedTask.bind(this);
    this.removeSelectedTask = this.removeSelectedTask.bind(this);
    this.getBuildTasks = this.getBuildTasks.bind(this);
  }

  handleProjectRetrieved(project, action, acData, fetchdData) {
    const path = this.props.history.parseParameters();
    this.setState({ project });
    if (path.params.user_id) {
      this.userDataSource = new DataSource('User', +path.params.user_id, { user: { } }, this.handleUserRetrieved);
    }
    if (this.buildDataSource) {
      this.buildDataSource.get();
    }
    else {
      if (this.userDataSource) {
        this.userDataSource.get();
      }
    }
  }

  handleBuildRetreived(build, action, acData, fetchedData) {
    const path = this.props.history.parseParameters();
    this.setState({ build });
    if (!path.params.bulk_assign && this.userDataSource) {
      this.userDataSource.get();
    }
    else {
      this.categorizeTasks(this.state.project, build);
    }
  }

  handleUserRetrieved(user, action, acData, fetchedData) {
    this.setState({ user });
    if (this.props.quickAssignments && this.buildDataSource) {
      this.buildDataSource.get();
    }
    else {
      this.categorizeTasks(this.state.project, this.state.build);
    }
  }

  handleInitializeDataSources() {
    const path = this.props.history.parseParameters();
    this.setState({ params: path.params }, () => {

      if (this.projectDataSource && (!this.state.params || this.state.params.project_id != path.params.project_id)) {
        this.projectDataSource.release();
        this.projectDataSource = null;
        this.setState({ project: null });
      }
      if (this.buildDataSource) {
        this.buildDataSource.release();
        this.buildDataSource = null;
        if (!this.state.params || this.state.params.project_id != path.params.project_id) {
          this.setState({ build: null });
        }
      }
  
      if (this.userDataSource) {
        this.userDataSource.release();
        this.userDataSource = null;
        this.setState({ user: null });
      }
  
      if (path.params.project_id) {
        this.projectDataSource = new DataSource('Project', +path.params.project_id, {
          project: {
            project_contacts: {
              user: {},
            },
            builds: {
              tasks: {
                user_task_assignments: {
                  user: {
                    additionalFields: ['profile_image'],
                    companies: {},
                  },
                },
              },
            },
          },
        }, this.handleProjectRetrieved);
        this.projectDataSource.get();
      }

      if (path.params.build_id || this.props.quickAssignments) {
        if (path.params.build_id == 'all' || !path.params.build_id) {
          this.buildDataSource = new DataSource('Build', 'root_build', build_root, this.handleBuildRetreived, null, +path.params.project_id);
          this.buildDataSource.get();
        }
        else {
          this.buildDataSource = new DataSource('Build', +path.params.build_id, build_root, this.handleBuildRetreived, null, +path.params.project_id);
          this.buildDataSource.get();
        }
      }
    });
  }

  componentDidMount() {
    super.componentDidMount();
    this.handleInitializeDataSources();
  }

  componentWillUnmount() {
    if (this.projectDataSource) {
      this.projectDataSource.release();
      this.projectDataSource = null;
    }
    if (this.buildDataSource) {
      this.buildDataSource.release();
      this.buildDataSource = null;
    }

    if (this.userDataSource) {
      this.userDataSource.release();
      this.userDataSource = null;
    }
  }

  componentDidUpdate(prevProps) {
    const path = this.props.history.parseParameters();
    if (!_.isEqual(path.params, this.state.params)) {
      this.handleInitializeDataSources();
    }
  }
  
  getBuildTasks(build, tasks) {
    if (build.tasks) {
      for (let task of build.tasks) {
        tasks.push(task);
      }
    }
    if (build.builds){
      for (let subBuild of build.builds){
        if (subBuild){
          this.getBuildTasks(subBuild, tasks);
        }
      }
    }
  }

  async categorizeTasks(project, build) {
    const myTasksNotStarted = { tasks: [] };
    const myTasksInProgress = { tasks: [] };
    const myTasksUnderReview = { tasks: [] };
    const myTasksCompleted = { tasks: [] };
    const flattenedTasks = [];

    let tasks = null;
    if (build) {
      tasks = [];
      this.getBuildTasks(build, tasks);
    }
    else {
      tasks = this.props.quickAssignments && project.tasks && project.tasks.length ? project.tasks : null;
    }
    if (!tasks) return;
    for (let task of tasks) {
      if (this.props.permissions.canViewTask) {
        flattenedTasks.push(task);
        switch (task.status) {
        case 'not_started':
          myTasksNotStarted.tasks.push(task);
          break;
        case 'in_progress':
          myTasksInProgress.tasks.push(task);
          break;
        case 'pending_review':
        case 'pending_approval':
          myTasksUnderReview.tasks.push(task);
          break;
        case 'completed':
          myTasksCompleted.tasks.push(task);
          break;
        default:
          break;
        }
      }
    }
    this.setState({ myTasksNotStarted, myTasksInProgress, myTasksUnderReview, myTasksCompleted, flattenedTasks, tasksInitialized: true });
  }

  addSelectedTask(task) {
    this.selectedTaskIds.add(task.id);
    this.selectedTasks.push(task);
    this.setState({ selectedTasksCount: this.selectedTasks.length });
  }

  removeSelectedTask(task) {
    this.selectedTaskIds.delete(task.id);
    const indexToDelete = this.selectedTasks.findIndex(selectedTask => selectedTask.id == task.id);
    this.selectedTasks.splice(indexToDelete, 1);
    this.setState({ selectedTasksCount: this.selectedTasks.length });
  }

  handleEditCancel() {
    this.setState({ editing: false, editedBuild: null });
  }

  handleBackArrow() {
    if (this.props.handleBackArrow) {
      this.props.handleBackArrow();
    }
    else {
      if (this.props.build && this.props.build.ancestry) {
        const ancestryArray = this.props.build.ancestry.split('/');
        if (ancestryArray.length > 0) {
          const parentId = parseInt(ancestryArray[ancestryArray.length - 1], 10);
          this.handleGoToBuild(this.state.project, parentId, this.props.build);
        } else {
          this.props.history.push(
            '/projects/' + this.state.project.id + '/build/all'
          );
        }
      } else if (this.state.project) {
        this.props.history.push('/projects/' + this.state.project.id);
      }
    }
  }

  handleDeleteTask(task) {
    dataModel.tasksDAO.delete(task.id);
    this.handleBackArrow();
  }

  handleCancelAdd() {
    this.setState({ displayAddCard: false });
  }

  handleExpansion(height) {
    const expandedValue = (height > 20);
    if (this.props.closeMap) {
      this.props.closeMap(expandedValue);
    }
    PageStateDAO.setPageStateEntry(PageNames.PROJECTS_CONTAINER, 'mapExpanded', expandedValue);
    this.setState({ displayHeight: height + (height == 0 ? 0 : 20), mapExpanded: expandedValue });
  }

  logQuickAssignAction() {
    const { currentCompany, currentUser } = this.props;
    const project = this.state.project;
      
    let eventAction = 'ProjectMemberAssign';

    //if BO is the one doing the assignment
    if (BuildOwnerPermissionsUtil.isBuildOwnerInProject(project, currentUser) 
        && BuildOwnerPermissionsUtil.isBuildOwnerInVendorCompany(currentCompany, currentUser))  {
      eventAction = 'ProjectMemberAssignBO';
    }

    if (this.props.quickAssignments) { 
      for (let key in this.props.quickAssignments) {
        if (key) {
          this.analyticsLogger.logProjectMemberAssignment(eventAction, key);
        }
      }
    }
  }

  handleCancel(dontCheck) {
    if (dontCheck) {
      this.selectedTaskIds = new Set();
      this.selectedTasks = [];
      this.setState({ selectedTasksCount: 0 });
    }
    if (!dontCheck) {
      this.analyticsLogger.logQuickAssignCancel();
    }
    const { quickAssignments } = this.props;

    if (quickAssignments) {
    }
    else {
      
    }
    dataModel.usersDAO.quickAssignments = null;
    const currentPage = this.props.history.getCurrentLocation();
    if (this.state.build && currentPage.pathname.toLowerCase().indexOf('build') >= 0 && currentPage.pathname.toLowerCase().indexOf('all') < 0) {
      this.props.history.replace(
        '/projects/' + this.state.project.id + '/build/' + this.state.build.id
      );
    }
    else {
      this.props.history.replace(
        '/projects/' + this.state.project.id + '/build/all'
      );
    }
  }

  async doAssignmentSave() {
    dataModel.inProgress = 10000;
    const { quickAssignments } = this.props;
    let bulkAssignErrors = [];
    for (let key in quickAssignments) {
      if (key) {
        const assignmentType = key == 'task-notify' ? 'notify' : key;
        for (let userId in quickAssignments[key]) {
          if (userId) {
            let user = quickAssignments[key][userId];
            const requestData = { user_id: user.id, assignment_type: assignmentType, tasks: [] };
            for (let task of this.selectedTasks) {
              requestData.tasks.push(task.id);
            }
            const userErrors = await dataModel.tasksDAO.bulkAssign(requestData);
            if (userErrors) {
              userErrors.forEach(ue => {
                if (!bulkAssignErrors.find(bae => { return bae.id == ue.id; })) {
                  bulkAssignErrors.push(ue);
                }
              });
            }
          }
        }
      }
    }
    this.logQuickAssignAction();
    this.handleCancel(true);
    dataModel.inProgress = 0;

    if (bulkAssignErrors.length) {
      this.setState({ bulkAssignErrors });
    }
  }

  handleBulkAssignSave() {
    if (!this.state.selectedTasksCount) {
      this.handleCancel(true);
    } else {
      this.doAssignmentSave();
    }
  }

  doDeleteTask() {
    this.handleDeleteTask(this.state.selectedTask);
  }

  handleTaskDelete() {
    const message = 'Are you sure you want to delete this task?';

    this.props.dataModel.showGlobalModal('SYSTEM_POPUP', {
      message: message,
      cancelButtonText: this.textMap.no.toUpperCase(),
      okButtonText: this.textMap.yes.toUpperCase(),
      width: 300,
      height: 200,
      handleOwnerOk: () => {
        this.doDeleteTask();
      },
    });
  }

  handleBuildOwnerTaskSave(editedTask, bulkAssignRoute) {
    if (bulkAssignRoute) {
      dataModel.showGlobalModal('SYSTEM_POPUP', {
        message: 'You have selected a user who is not part of your company. Would you like to continue?',
        cancelButtonText: 'NO',
        okButtonText: 'CONTINUE',
        width: 320,
        height: 182,
        handleOwnerOk: () =>  {
          bulkAssignRoute();
        },
      });
    }
  }

  handleAddCopiedTask(newTask, originalTask) {
    const { myTasksNotStarted } = this.state;
    const copyFlatTasks = [...myTasksNotStarted.tasks];

    const originalTaskIndex = copyFlatTasks.findIndex(task => task.id == originalTask.id);
    if (originalTaskIndex < 0) {
      copyFlatTasks.push(newTask);
    }
    else {
      copyFlatTasks.splice((originalTaskIndex + 1), 0, newTask);
    }

    this.setState({ myTasksNotStarted: { tasks: copyFlatTasks } });
  }

  handleDisplayQuickerAssign(project, isVendorBuildOwner, quickerAssignUser) {
    this.setState({ displayQuickerAssignPopup: project, isVendorBuildOwner, quickerAssignUser });
  }

  handleCloseQuickerAssign() {
    this.setState({ displayQuickerAssignPopup: null });
  }

  handleCloseQuickerAssignError() {
    this.setState({ bulkAssignErrors: null });
  }

  render() {

    if (!this.state.params || !this.state.project) {
      return null;
    }
    const { selectedTasksCount } = this.state;

    let subHeader = null;
    
    let waitSpinner = null;
    if (!this.state.tasksInitialized) {
      waitSpinner = <WaitSpinner />;
    }

    if (!this.props.quickAssignments) {
      subHeader = (
        <div className="project-tasks-subheader">
          <BreadCrumbs history={this.props.history} menu={this.state.menu}/>
        </div>
      );
    }

    let headerOverlay = null;
    if (this.props.quickAssignments) {
      headerOverlay = <div className={'project-header-overlay'} />;
    }

    let quickerAssignContainer = null;
    if (this.state.displayQuickerAssignPopup) {
      quickerAssignContainer =
        (
        <Modal show={true}>
          <QuickerAssignPopup
            projectId={this.state.displayQuickerAssignPopup.id}
            buildId={this.state.build ? this.state.build.id : 'all'}
            handleClosePopup={this.handleCloseQuickerAssign}
            isVendorBuildOwner={this.state.isVendorBuildOwner}
            currentCompany={this.props.currentCompany}
            selectedUser={this.state.quickerAssignUser}
            currentUser={this.props.currentUser}
          />
          </Modal>
        );
    }

    let quickerAssignErrorContainer = null;
    if (this.state.bulkAssignErrors) {
      quickerAssignErrorContainer =
        (
        <Modal show={true}>
          <QuickerAssignErrorPopup
            handleClosePopup={this.handleCloseQuickerAssignError}
            currentCompany={this.props.currentCompany}
            currentUser={this.props.currentUser}
            bulkAssignErrors={this.state.bulkAssignErrors}
          />
          </Modal>
        );
    }

    let containerStyle = {};
    let instructionPopout = null;
    if (!this.props.quickAssignments) {
      // containerStyle = { top: 135 + this.state.displayHeight }
    }
    else {
      instructionPopout = (
        <AssignmentPullout
          selectedUser={this.state.user}
          quickAssignments={this.props.quickAssignments}
          selectedCount={selectedTasksCount}
          handleSave={this.handleBulkAssignSave}
          handleCancel={this.handleCancel}
        />
      );
    }
    
    return (
      <div className={'projects-container-tasks' + (this.props.quickAssignments ? ' bulk-assign' : '')}>
        {quickerAssignContainer}
        {quickerAssignErrorContainer}
        <ProjectHeader
          projectId={this.state.project ? this.state.project.id : null}
          allProjects={this.props.allProjects}
          build={this.state.build}
          type="builds-page"
          mapExpanded={this.state.mapExpanded}
          dontAllowAdd={false}
          handleExpansion={this.handleExpansion}
          permissions={this.props.permissions}
          new_projects={this.props.new_projects}
          inProjectsTab={true}
          updateProject={this.props.updateProject}
          handleBuildOwnerTaskSave={this.handleBuildOwnerTaskSave}
          displayQuickerAssign={this.handleDisplayQuickerAssign}
          isLeftDividerHide={true}
        />

        {waitSpinner}
        {headerOverlay}
        {instructionPopout}
        <div className={'project-tasks-container' + (this.props.quickAssignments ? ' bulk-assign' : '')} style={containerStyle}>
          {subHeader}
          <div className={'project-tasks-detail my-tasks'}>
            <TaskSwimLanes
              addSelectedTask={this.addSelectedTask}
              build={this.state.build}
              quickAssignments={this.props.quickAssignments}
              currentCompany={this.props.currentCompany}
              currentUser={this.props.currentUser}
              getNextPage={() => {}} // currently only paginating in tasks tab
              inProjectsTab={true}
              mapExpanded={this.state.mapExpanded}
              myTasksCompleted={this.state.myTasksCompleted}
              myTasksInProgress={this.state.myTasksInProgress} 
              myTasksNotStarted={this.state.myTasksNotStarted}
              myTasksUnderReview={this.state.myTasksUnderReview}
              permissions={this.props.permissions}
              removeSelectedTask={this.removeSelectedTask}
              selectedProject={this.state.project}
              selectedTaskIds={this.selectedTaskIds}
              selectedUser={this.state.user}
              handleAddCopiedTask={this.handleAddCopiedTask}
              updateProject={this.props.updateProject}
            />
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    dataModel: dataModel,
    inProgress: state.main.inProgress,
    permissions: state.new_users.permissions,
    new_projects: state.new_projects,
    currentUser: state.new_users.currentUser,
    quickAssignments: state.new_users.quickAssignments,
    currentCompany: state.new_companies.currentCompany,
  };
};

export default withRouter(connect(mapStateToProps)(ProjectsContainerTasks));



// WEBPACK FOOTER //
// ./src/containers/ProjectsContainer/ProjectsContainerTasks/index.js